module.exports = __webpack_public_path__ + "static/img/website_1.2bb4a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/website_1.png
// module id = eciM
// module chunks = 1